import ListPrilaku from "../../../../../components/categories/siakad/laporan_adab/penilaian_karyawan/sub_page/Home";
export default function Home() {
  
  return (
    <ListPrilaku />
  );
}
